import React, { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { Rule } from "./type";
import VikingBlastUtils from "./utils";

export const VikingBlastRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  return (
    <>
      <h5 className="card-title">Game Rule</h5>
      <p className="card-text">
        Each gem's winning combination payout are as according to the Paytable
        below.
      </p>
      <div className="card-text">
        <div className="row">
          {Object.entries(payouts).map(([symbol, payout], i) => (
            <div key={symbol} className="col-6 col-md-3 pb-3">
              <div className="row justify-content-center">
                <div className="symbol">
                  {VikingBlastUtils.convertSymbol(+symbol)}
                </div>
              </div>
              <div className="row justify-content-center">{payout}</div>
            </div>
          ))}
        </div>
      </div>
      <p className="card-text">
        On every play, any combination of 4 or more of the same gem symbols
        aligned horizontally or vertically will result in a winning combination
      </p>
      <p className="card-text">
        After every matching gem combinations, the gem symbols will blast off
        the map, allowing symbols above them to cascade down into a new play.
      </p>
      <p className="card-text">
        Additional winning combinations will be tallied in every round until no
        more winning combination can be tallied.
      </p>
      <p className="card-text">
        During a round, 3 scatters symbols appear to enter the bonus game.
      </p>
      <div className="card-text">
        <div className="row">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={`scatter-${i}`} className="col-6 col-md-3 pb-3">
              <div className="row justify-content-center">
                <div className="symbol">
                  {VikingBlastUtils.convertSymbol(25)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="card-text">
        For each symbol on the board, increase 1x for an exponential bonus.
      </p>
      <p className="card-text">
        Free spin are played with 3 random symbols.
        <br />
        <img src="/vb/buyfreespins.png" alt="buyfreespins" />
      </p>
    </>
  );
};
